export default [
  // 以旧换新首页 - 新
  {
    path: '/recycle',
    name: 'recycle',
    meta: { type: 'page', title: '以旧换新', stParams: {} },
    component: () => import(/* webpackChunkName: 'recycle' */ 'views/recycle/index.vue'),
    redirect: '/recycle/index',
    children: [
      {
        path: '/recycle/index',
        name: 'recycleHome',
        meta: { type: 'page', title: '以旧换新', stParams: {} },
        component: () => import(/* webpackChunkName: 'recycle' */ 'views/recycle/home')
      },
      // 以旧换新 - 回收订单列表
      {
        path: '/my/recycle/order/list',
        name: 'orderList',
        meta: { type: 'page', title: '回收订单', stParams: {} },
        component: () => import(/* webpackChunkName: 'recycle' */ 'views/recycle/orderList')
      }
    ]
  },
  // 以旧换新 - 机型选择
  {
    path: '/recycle/phones',
    name: 'phones',
    redirect: '/recycle/phones/index',
    meta: { type: 'page', title: '旧机机型选择', stParams: {} },
    component: () => import(/* webpackChunkName: 'recycle' */ 'views/recycle/phone-parent'),
    children: [
      {
        path: '/recycle/phones/index',
        name: 'phones',
        meta: { type: 'page', title: '旧机机型选择', stParams: {} },
        component: () => import(/* webpackChunkName: 'recycle' */ 'views/recycle/phones')
      },
      {
        path: '/recycle/phones/search',
        name: 'phones',
        meta: { type: 'page', title: '机型搜索', stParams: {} },
        component: () => import(/* webpackChunkName: 'recycle' */ 'views/recycle/search')
      }
    ]
  },
  {
    path: '/recycle/result',
    name: 'result',
    meta: { type: 'page', title: '一站式换新', stParams: {}, lightDark: 1 },
    component: () => import(/* webpackChunkName: 'recycle' */ 'views/product/recycle/result')
  }
]
